import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../../ui/Tooltip'
import ImageIcon from '../../ui/icons/ImageIcon'
import CommentIcon from '../../ui/icons/CommentIcon'

const ICON_CLASS = 'tw:text-gray-500 tw:text-xl tw:inline-flex'

const photoLabel = count => `${count} photo${count > 1 ? 's' : ''}`

const ContentCell = ({ photosCount = 0, hasComment = false, comment = '' }) => {
  if (photosCount === 0 && !hasComment)
    return <span className="tw:text-gray-500">--</span>
  return (
    <div className="tw:flex tw:items-center tw:gap-2">
      {photosCount > 0 ? (
        <Tooltip content={photoLabel(photosCount)}>
          <span aria-label={photoLabel(photosCount)} className={ICON_CLASS}>
            <ImageIcon />
          </span>
        </Tooltip>
      ) : null}
      {hasComment ? (
        <Tooltip content={comment}>
          <span aria-label="Commentaire" className={ICON_CLASS}>
            <CommentIcon />
          </span>
        </Tooltip>
      ) : null}
    </div>
  )
}

ContentCell.propTypes = {
  comment: PropTypes.string,
  hasComment: PropTypes.bool,
  photosCount: PropTypes.number
}

ContentCell.defaultProps = {
  comment: '',
  hasComment: false,
  photosCount: 0
}

export default ContentCell
